import BowlerMembership from '../Steps/BowlerMembership/BowlerMembership';
import EditBowlerInfo from '../Steps/EditBowlerInfo/EditBowlerInfo';
import MembershipCostAck from '../Steps/MembershipCostAck/MembershipCostAck';
import MembershipSearch from '../Steps/MembershipSearch/MembershipSearch';
import ParticipantType from '../Steps/ParticipantType/ParticipantType';
import ViewBowlerInfo from '../Steps/ViewBowlerInfo/ViewBowlerInfo';
import Consent from '../Steps/Consent/Consent';
import ReviewAndPay from '../Steps/ReviewAndPay/ReviewAndPay';
import Finished from '../Steps/Finished/Finished';
import { mainStepsIds } from './constants'
import { subStepsIds } from './constants'

export let subSteps = [
    {
        id: subStepsIds.ParticipantType,
        title: "Who will be participating in",
        parent: mainStepsIds.Start,
        content: (props) => <ParticipantType {...props} />,
    },
    {
        id: subStepsIds.BowlerMembership,
        title: "Is this bowler a current or previous USBC member?",
        parent: mainStepsIds.Start,
        content: (props) => <BowlerMembership {...props} />
    },
    {
        id: subStepsIds.MembershipSearch,
        title: 'Find the USBC Member Id of the bowler you are registering',
        parent: mainStepsIds.Membership,
        content: (props) => <MembershipSearch {...props} />
    },
    {
        id: subStepsIds.MembershipCostAck,
        title: 'USBC Membership Information',
        parent: mainStepsIds.Membership,
        content: (props) => <MembershipCostAck {...props} />
    },
    {
        id: subStepsIds.ViewBowlerInfo,
        title: 'Bowler registration',
        parent: mainStepsIds.Bowler,
        content: (props) => <ViewBowlerInfo {...props} />
    },
    {
        id: subStepsIds.EditBowlerInfo,
        title: 'Bowler registration',
        parent: mainStepsIds.Bowler,
        content: (props) => <EditBowlerInfo {...props} />
    },
    {
        id: subStepsIds.Consent,
        title: 'Terms of Service and Privacy Policy',
        parent: mainStepsIds.Consent,
        content: (props) => <Consent {...props} />
    },
    {
        id: subStepsIds.ReviewAndPay,
        title: 'Review & Pay',
        parent: mainStepsIds.ReviewAndPay,
        content: (props) => <ReviewAndPay {...props} />
    },
    {
        id: subStepsIds.Finished,
        title: 'Finished',
        parent: mainStepsIds.Finished,
        content: (props) => <Finished {...props} />
    }
];
